import { differenceInHours } from 'date-fns';

import { convertDate } from '@flipster/utils/datetime';

export const getEstimatedHours = (time: string | undefined) => {
  if (!time) return 0;
  return differenceInHours(convertDate(time) ?? new Date(), new Date(), { roundingMethod: 'ceil' });
};
